export class User {
  uuid: string;
  username: string;
  tenantUUID: string;
  organizationUUID: string;
  email: string;
  emailVerified: boolean;
  enabled: boolean;
  firstName: string;
  lastName: string;
  requieredActions: string[];
  language: string;
  timeZone: string;
}

export class UserCredentials {
  value: string;
  confirmValue: string;
  temporal: boolean;
}

export class UserApplications {
  available: string[];
  superadmin: string[];
  admin: string[];
  viewer: string[];
  operator: string[];
}
